
import profile_img from '../../assets/images/pages/defaultImage.jpg'
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { GlobalContext, handleError } from '../../context/Provider';
import henceforthApi from '../../utils/henceforthApi';
import loginSuccess from '../../context/actions/auth/loginSuccess';
import Spinner from '../../components/common/spinner';
import PhoneInput from 'react-phone-input-2';
import Errormessage from '../../components/common/errormessage';
import Svg from '../../components/common/error-svg';
import BreadCrumb from '../../components/common/BreadCrumb';
import { documentId, validateEmail } from '../../utils/validations';
import Inputs, { SaveCancelButton } from '../../components/common/Inputs';
import Textarea from '../../components/common/Textarea';
import { toast } from 'react-toastify';
import { capitalise, NumberValidation } from "../../utils/validations"

const EditProfile = () => {
    const { language_data, authState, authDispatch, loading, setLoading, toastMessage } = useContext(GlobalContext)

    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Profile', url: `/profile`, active: '' },
        { name: 'Edit Profile', url: ``, active: 'not-allowed' },
    ]
    const [nameErr, setNameErr] = useState<string>('')
    const [emailErr, setEmailErr] = useState<string>('')
    const [phoneEr, setPhoneEr] = useState<string>('')
    const [cityErr, setCityErr] = useState<string>('')
    const [stateErr, setStateErr] = useState<string>('')
    const [companyErr, setCompanyErr] = useState<string>('')
    const [pinCodeErr, setPinCodeErr] = useState<string>('')
    const [selectedFile, setSelectedFile] = useState<any>()
    const [fullAddressErr, setFullAddressErr] = useState<string>('')
    const [apartmentNoErr, setApartmentNoErr] = useState<string>('')
    const placeInputRef = useRef(null) as React.MutableRefObject<any>
    
    // Document states
    const [newDocumentFiles, setNewDocumentFiles] = useState<{[key: string]: {front?: File, back?: File}}>({})
    const [removedDocuments, setRemovedDocuments] = useState<string[]>([])
    const [documentTypes, setDocumentTypes] = useState<Array<{type: string, label: string}>>([])
    
    // Fetch document types from API
    useEffect(() => {
        const fetchDocumentTypes = async () => {
            try {
                const response = await henceforthApi.Auth.getDocumentTypes();
                if (response && response.data && Array.isArray(response.data)) {
                    setDocumentTypes(response.data);
                } else {
                    setDocumentTypes([
                        { type: 'aadhar_card', label: 'Aadhar Card' },
                        { type: 'pan_card', label: 'PAN Card' }
                    ]);
                }
            } catch (error) {
                console.error('Error fetching document types:', error);
                setDocumentTypes([
                    { type: 'aadhar_card', label: 'Aadhar Card' },
                    { type: 'pan_card', label: 'PAN Card' }
                ]);
            }
        };
        
        fetchDocumentTypes();
    }, []);

    const [updateProfile, setUpdateProfile] = useState({
        name: authState.name ?? "",
        email: authState.email ?? "",
        phone_number: authState.phone_number ?? "",
        country_code: authState.country_code ?? "",
        company: authState.company ?? "",
        state: authState.state ?? "",
        city: authState.city ?? "",
        pin_code: authState.pin_code ?? "",
        apartment_number: authState.apartment_number ?? "",
        full_address: authState.full_address ?? "",
        image: authState.image ?? "",
        latitude: "",
        longitude: "",
        delivery_provide: authState.delivery_provide ?? false,
    })

    // Helper function to get image URL
    const getImageUrl = (image: string | null | undefined) => {
        if (!image) return profile_img;
        return image.endsWith('.webp') 
            ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${image}` 
            : `${henceforthApi.API_FILE_ROOT_MEDIUM}${image}`;
    }

    // Helper function to get document image URL
    const getDocumentImageUrl = (image: string | null | undefined) => {
        if (!image) return profile_img;
        return image.endsWith('.webp') 
            ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${image}` 
            : `${henceforthApi.API_FILE_ROOT_MEDIUM}${image}`;
    }

    const changeProfileDetails = ({ target }: any) => {
        const val = target.value;
        const name = target.name;
        if (name === 'name') setNameErr('')
        if (name === 'email') setEmailErr('')
        if (name === 'company') setCompanyErr('')
        if (name === 'state') setStateErr('')
        if (name === 'city') setCityErr('')
        if (name === 'pin_code' && !NumberValidation(val)) return
        if (name === 'apartment_number') setApartmentNoErr('')
        if (name === 'full_address') setFullAddressErr('')
        setUpdateProfile({
            ...updateProfile,
            [name]: val
        })
    }

    const uploadImage = async (e: any) => {
        try {
            const apiRes = await henceforthApi.Common.do_spaces_file_upload(`file`, e)
            let items = { image: apiRes.data.file_name }
            let res = await henceforthApi.Auth.editProfile(items)
            loginSuccess(res.data)(authDispatch)
        } catch (err) {
            setLoading(false)
            handleError(err, '', authDispatch);
        }
    }

    const fileUpload = async (file: any) => {
        setLoading(true)
        const apiRes = await henceforthApi.Common.do_spaces_file_upload("file", file)

        const data1 = {
            image: apiRes.data.file_name
        };
        await henceforthApi.Auth.editProfile(data1)
            .then((res: any) => {
                setLoading(false);
                loginSuccess(res.data)(authDispatch);
            })
            .catch((err: any) => {
                console.log(err);
                setLoading(false);
            });
    }

    const onKeyDown = (keyEvent: any) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            keyEvent.preventDefault();
        }
    }

    const editProfile = async (e: any) => {
        e.preventDefault();
        const { name, country_code, phone_number, company, city, pin_code, apartment_number, email, full_address, state, delivery_provide } = updateProfile;
        
        if (!name && !phone_number && !company && !city && !pin_code && !full_address && !state) {
            setCityErr(`${language_data?.[authState.lang]?.common_city} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setNameErr(`${language_data?.[authState.lang]?.common_name} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setPhoneEr(`${language_data?.[authState.lang]?.common_phone} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setCompanyErr(`${language_data?.[authState.lang]?.common_company} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setPinCodeErr(`${language_data?.[authState.lang]?.common_pin_code} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setFullAddressErr(`${language_data?.[authState.lang]?.common_full} ${language_data?.[authState.lang]?.common_address} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
            setStateErr(`${language_data?.[authState.lang]?.common_state} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`)
        }
        if (!updateProfile.name) { documentId('name'); setNameErr(`${language_data?.[authState.lang]?.common_name} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.name.trim()) { documentId('name'); setNameErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_name}`); return }
        if (!updateProfile.email.trim()) { documentId('email'); setEmailErr(`${language_data?.[authState.lang]?.common_email} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!validateEmail(updateProfile.email)) { documentId('email'); setEmailErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_fill} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_email}`); return }
        if (!updateProfile.phone_number) { documentId('phone'); toast.warn(`${language_data?.[authState.lang]?.common_phone} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); setPhoneEr(`${language_data?.[authState.lang]?.common_phone}${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (updateProfile.phone_number.length < 10 || updateProfile.phone_number.length > 12) { documentId('phone'); toast.warn(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid}${language_data?.[authState.lang]?.common_numbers}`); setPhoneEr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid}${language_data?.[authState.lang]?.common_numbers}`); return }
        if (!updateProfile.company) { documentId('company'); setCompanyErr(`${language_data?.[authState.lang]?.common_company} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.company.trim()) { documentId('company'); setCompanyErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_company}`); return }
        if (!updateProfile.full_address) { documentId('full_address'); setFullAddressErr(`${language_data?.[authState.lang]?.common_full} ${language_data?.[authState.lang]?.common_address} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.full_address.trim()) { documentId('full_address'); setFullAddressErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_full} ${language_data?.[authState.lang]?.common_address}`); return }
        if (!updateProfile.state) { documentId('state'); setStateErr(`${language_data?.[authState.lang]?.common_state} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.state.trim()) { documentId('state'); setStateErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_state}`); return }
        if (!updateProfile.city) { documentId('city'); setCityErr(`${language_data?.[authState.lang]?.common_city} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.city.trim()) { documentId('city'); setCityErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_city}`); return }
        if (!updateProfile.pin_code) { documentId('pin_code'); setPinCodeErr(`${language_data?.[authState.lang]?.common_pin_code} ${language_data?.[authState.lang]?.common_is} ${language_data?.[authState.lang]?.common_required}`); return }
        if (!updateProfile.pin_code.trim()) { documentId('pin_code'); setPinCodeErr(`${language_data?.[authState.lang]?.common_please} ${language_data?.[authState.lang]?.common_provide} ${language_data?.[authState.lang]?.common_valid} ${language_data?.[authState.lang]?.common_pin_code} `); return }
        
        setLoading(true)
        
        // Geocode address if lat/lng are empty but address fields have values
        let { latitude, longitude } = updateProfile;
        if (!latitude || !longitude) {
            const coordinates = await handleAddressGeocode();
            if (coordinates) {
                latitude = coordinates.lat;
                longitude = coordinates.lng;
            }
        }

        let data = !apartment_number.trim() ? {
            name: name,
            phone_number: phone_number,
            country_code: country_code,
            company: company,
            city: city,
            state: state,
            pin_code: pin_code,
            language: 'ENGLISH',
            full_address: full_address,
            delivery_provide: delivery_provide,
        } as any : {
            name: name,
            phone_number: phone_number,
            country_code: country_code,
            company: company,
            city: city,
            state: state,
            pin_code: pin_code,
            apartment_number: apartment_number,
            full_address: full_address,
            delivery_provide: delivery_provide,
            language: 'ENGLISH',
        } as any

        if (latitude && longitude) {
            data.latitude = latitude;
            data.longitude = longitude;
        }
        if (!authState.email_verified) data['email'] = email;
        if (selectedFile) {
            const image = await fileUpload(selectedFile)
            data.image = image
        }
    
        const allDocuments: any[] = [];
        
        if ((authState as any)?.documents && (authState as any).documents.length > 0) {
            const uploadedDocuments = await Promise.all(
                (authState as any).documents.map(async (doc: any) => {
                    let frontKey = doc.images?.front || '';
                    let backKey = doc.images?.back || '';
                
                    if (newDocumentFiles[doc._id]?.front) {
                        const frontUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', newDocumentFiles[doc._id].front!);
                        frontKey = frontUploadRes.data.file_name;
                    }
                    
                    if (newDocumentFiles[doc._id]?.back) {
                        const backUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', newDocumentFiles[doc._id].back!);
                        backKey = backUploadRes.data.file_name;
                    }
                    
                    return {
                        _id: doc._id,
                        type: doc.type,
                        images: {
                            front: frontKey,
                            back: backKey
                        },
                        removed: removedDocuments.filter(r => r.startsWith(`${doc._id}-`))
                    };
                })
            );
            
            allDocuments.push(...uploadedDocuments);
        }
        
        const newDocTypes = documentTypes.filter(docType => 
            !(authState as any)?.documents?.find((d: any) => d.type === docType.type)
        );
        
        if (newDocTypes.length > 0) {
            const newUploadedDocs = await Promise.all(
                newDocTypes.map(async (docType) => {
                    let frontKey = '';
                    let backKey = '';
                    
                    if (newDocumentFiles[docType.type]?.front) {
                        const frontUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', newDocumentFiles[docType.type].front!);
                        frontKey = frontUploadRes.data.file_name;
                    }
                    
                    if (newDocumentFiles[docType.type]?.back) {
                        const backUploadRes = await henceforthApi.Common.do_spaces_file_upload('file', newDocumentFiles[docType.type].back!);
                        backKey = backUploadRes.data.file_name;
                    }
                    if (frontKey || backKey) {
                        return {
                            type: docType.type,
                            images: {
                                front: frontKey,
                                back: backKey
                            }
                        };
                    }
                    return null;
                })
            );
            allDocuments.push(...newUploadedDocs.filter(doc => doc !== null));
        }
        
        if (allDocuments.length > 0) {
            data.documents = allDocuments;
        }
        
        try {
            let res = await henceforthApi.Auth.editProfile(data)
            loginSuccess(res.data)(authDispatch)
            toastMessage(res.message ? res.message : `${language_data?.[authState.lang]?.common_success}`);
            window.history.back()
        }
        catch (err) {
            handleError(err, 'active', authDispatch);
        } finally {
            setLoading(false)
        }
    }

    const phoneCheck = (e: any, v: any) => {
        setPhoneEr('')
        setUpdateProfile({
            ...updateProfile,
            phone_number: e.phone.slice(Number(v.dialCode.length), Number(e.phone.length)),
            country_code: v.dialCode,
        });
    }

    function loadGoogleMapScript(callback: any) {
        if (
            typeof (window as any).google === "object" &&
            typeof (window as any).google.maps === "object"
        ) {
            callback();
        } else {
            const googleMapScript = document.createElement("script");
            googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD1CuR295O6gnkuW1tHdPMjqFpQewhAsD4&libraries=places`;
            window.document.body.appendChild(googleMapScript);
            googleMapScript.addEventListener("load", callback);
        }
    }

    const geocodeAddress = async (address: string): Promise<{ lat: string; lng: string } | null> => {
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=AIzaSyD1CuR295O6gnkuW1tHdPMjqFpQewhAsD4`
            );
            const data = await response.json();
            if (data.status === 'OK' && data.results && data.results.length > 0) {
                if (data.results[0].partial_match) {
                    console.warn('Geocoding returned partial match, skipping:', data.results[0]);
                    return null;
                }
                const location = data.results[0].geometry.location;
                return { lat: location.lat.toString(), lng: location.lng.toString() };
            }
        } catch (error) {
            console.error('Geocoding error:', error);
        }
        return null;
    };

    const handleAddressGeocode = async (): Promise<{ lat: string; lng: string } | null> => {
        const { full_address, city, state, pin_code } = updateProfile;
        if (city && state) {
            const addressString = [city, state, pin_code, full_address].filter(Boolean).join(', ');
            const coordinates = await geocodeAddress(addressString);
            if (coordinates) {
                setUpdateProfile((prev: any) => ({
                    ...prev,
                    latitude: coordinates.lat,
                    longitude: coordinates.lng,
                }));
                return coordinates;
            }
        }
        return null;
    };

    const initPlaceAPI = () => {
        loadGoogleMapScript(() => {
            if (placeInputRef) {
                let autocomplete = new (window as any).google.maps.places.Autocomplete(
                    placeInputRef.current
                );

                autocomplete.addListener("place_changed", () => {
                    let place = autocomplete.getPlace();

                    let formatAddress = place.formatted_address;
                    let lat = place.geometry?.location?.lat();
                    let lng = place.geometry?.location?.lng();

                    const address = place.address_components;

                    let items: any = {};

                    if (Array.isArray(address)) {
                        address.forEach((comp: any) => {
                            if (comp.types.includes("postal_code")) {
                                items.pin_code = comp.long_name;
                            }
                            if (comp.types.includes("administrative_area_level_1")) {
                                items.state = comp.long_name;
                            }
                            if (comp.types.includes("locality")) {
                                items.city = comp.long_name;
                            }
                            if (comp.types.includes("country")) {
                                items.country = comp.short_name; 
                            }
                            if (comp.types.includes("street_number")) {
                                items.apartment_number = comp.long_name;
                            }
                        });
                    }

                    items.full_address = formatAddress;
                    items.latitude = lat;
                    items.longitude = lng;

                    setUpdateProfile((prev: any) => ({
                        ...prev,
                        city: items.city || "",
                        state: items.state || "",
                        pin_code: items.pin_code || "",
                        apartment_number: items.apartment_number || "",
                        full_address: items.full_address || "",
                        latitude: items.latitude,
                        longitude: items.longitude,
                    }));

                    setCityErr('');
                    setStateErr('');
                    setPinCodeErr('');
                    setApartmentNoErr('');
                    setFullAddressErr('');
                });
            }
        });
    };

    useEffect(() => {
        initPlaceAPI()
    }, [])
    
    const handleDocumentUpload = (docId: string, side: 'front' | 'back', file: File) => {
        setNewDocumentFiles(prev => ({
            ...prev,
            [docId]: {
                ...(prev[docId] || {}),
                [side]: file
            }
        }))
    }
    
    const removeNewDocument = (docId: string, side: 'front' | 'back') => {
        setNewDocumentFiles(prev => {
            const updated = { ...(prev[docId] || {}) }
            delete updated[side]
            return { ...prev, [docId]: updated }
        })
    }
    
    const removeExistingDocument = (docId: string, side: 'front' | 'back') => {
        setRemovedDocuments(prev => [...prev, `${docId}-${side}`])
    }

    return (
        <Fragment>
            {/* breadcrum  */}
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            {/* page  */}
            <div className='page-spacing'>
                <section className='edit-profile'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-9 px-0">
                                {/* title  */}
                                <div className="common-card h-100">
                                    <div className="common-card-title">
                                        <h5>{language_data?.[authState.lang]?.common_edit} {language_data?.[authState.lang]?.common_profile}</h5>
                                    </div>
                                    {/* form  */}
                                    <div className="common-card-content">
                                        {/* Upload image */}
                                        <form onKeyDown={onKeyDown} onSubmit={editProfile}>
                                            <div className='upload-fields-box mb-3'>
                                                <div className='profile-edit-image mb-2'>
                                                    <div className='profile-edit-upload'>
                                                        <input type="file" onChange={(e: any) => setSelectedFile(e.target.files[0])} accept="image/*" />
                                                    </div>
                                                    <img 
                                                        src={selectedFile ? URL?.createObjectURL(selectedFile) : getImageUrl(authState?.image)} 
                                                        alt={authState?.image || 'Profile'} 
                                                        className='rounded-circle' 
                                                    />
                                                </div>
                                                <p className='text-center'><small><strong>{language_data?.[authState.lang]?.common_note}:-</strong> {language_data?.[authState.lang]?.common_please_upload_only_jpg_and_png_format_only}.</small></p>
                                            </div>

                                            {/* Name */}
                                            <Inputs.Input type="text" id="name" label={`${language_data?.[authState.lang]?.common_name}`} error={nameErr} value={updateProfile.name as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_name}`} name='name' handleChange={changeProfileDetails} />
                                            {/* Email */}
                                            <Inputs.Input type="text" id="email" label={`${language_data?.[authState.lang]?.common_email}`} value={updateProfile.email as any} error={emailErr} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_email}`} name='email' handleChange={changeProfileDetails} disabled={authState.email_verified} email_verified={authState.email_verified} />
                                            {/* Phone */}
                                            <div className={`form-fields-box mb-2 rounded-0 ${phoneEr ? 'border border-danger position-relative' : ''}`} id="phone">
                                                <label className='fw-bolder mb-1'>{language_data?.[authState.lang]?.common_phone} {language_data?.[authState.lang]?.common_no}.</label>
                                                <PhoneInput country={'in'} value={updateProfile.country_code.concat(updateProfile.phone_number)} inputProps={{ required: true }} onChange={(phone: any, value: any) => { phoneCheck({ phone }, value) }} />
                                                {phoneEr ? <span className='svg-question'><Svg /></span> : ''}
                                            </div>
                                            <Errormessage phone={phoneEr} error={phoneEr} />
                                            {/* Company */}
                                            <Inputs.Input type="text" id="company" label={`${language_data?.[authState.lang]?.common_company} ${language_data?.[authState.lang]?.common_name}`} error={companyErr} value={updateProfile.company as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_company}`} name='company' handleChange={changeProfileDetails} />
                                            {/* Address search */}
                                            <Inputs.InputRef type="text" label={`${language_data?.[authState.lang]?.common_search} ${language_data?.[authState.lang]?.common_location}`} ref={placeInputRef}
                                                handleChange={changeProfileDetails}
                                            />
                                            {/* Address */}
                                            <Textarea error={fullAddressErr} id="full_address" label={`${language_data?.[authState.lang]?.common_full} ${language_data?.[authState.lang]?.common_address}`} col={10} row={5} name='full_address' placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_full}${language_data?.[authState.lang]?.common_address}`} value={updateProfile.full_address as any} handleChange={changeProfileDetails} />
                                            {/* State */}
                                            <Inputs.Input type="text" id="state" label={`${language_data?.[authState.lang]?.common_state}`} error={stateErr} value={updateProfile.state as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_state}`} name='state' handleChange={changeProfileDetails} />
                                            {/* City */}
                                            <Inputs.Input type="text" id="city" label={`${language_data?.[authState.lang]?.common_state}`} error={cityErr} value={updateProfile.city as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_city}`} name='city' handleChange={changeProfileDetails} />
                                            {/* PinCode */}
                                            <Inputs.Input type="text" maxLength={6} id="pin_code" label={`${language_data?.[authState.lang]?.common_pin_code}`} error={pinCodeErr} value={updateProfile.pin_code as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your}${language_data?.[authState.lang]?.common_pin_code}`} name='pin_code' handleChange={changeProfileDetails} />
                                            {/* Appartment no. */}
                                            <Inputs.Input type="text" label={`${language_data?.[authState.lang]?.common_Apartment} ${language_data?.[authState.lang]?.common_number}`} error={apartmentNoErr} value={updateProfile.apartment_number as any} placeholder={`${language_data?.[authState.lang]?.common_enter_your} ${language_data?.[authState.lang]?.common_Apartment} ${language_data?.[authState.lang]?.common_number}`} name='apartment_number' handleChange={changeProfileDetails} />

                                            <div className="mb-3">
                                                <label className="fw-bold d-block">{language_data?.[authState.lang]?.common_home_delivery_provide || 'Delivery Provide'}</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="deliveryProvider"
                                                        id="deliveryYes"
                                                        value="yes"
                                                        checked={updateProfile.delivery_provide === true}
                                                        onChange={() => setUpdateProfile({ ...updateProfile, delivery_provide: true })}
                                                    />
                                                    <label className="form-check-label" htmlFor="deliveryYes">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="deliveryProvider"
                                                        id="deliveryNo"
                                                        value="no"
                                                        checked={updateProfile.delivery_provide === false}
                                                        onChange={() => setUpdateProfile({ ...updateProfile, delivery_provide: false })}
                                                    />
                                                    <label className="form-check-label" htmlFor="deliveryNo">
                                                        No
                                                    </label>
                                                </div>
                                            </div>

                                            {/* Documents Section - Always Show */}
                                            <div className="documents-edit-section mt-4 mb-3">
                                                <h6 className="fw-bold mb-3 pb-2 border-bottom">
                                                    {'Documents'}
                                                </h6>
                                                
                                                {documentTypes.map((docType) => {
                                                    const existingDoc = (authState as any)?.documents?.find((d: any) => d.type === docType.type);
                                                    const docId = existingDoc?._id || docType.type;
                                                    const hasFront = newDocumentFiles[docId]?.front;
                                                    const hasBack = newDocumentFiles[docId]?.back;
                                                    
                                                    return (
                                                        <div className="document-type-box mb-4 p-3 border rounded bg-white" key={docType.type}>
                                                            <h6 className="fw-bold mb-3">
                                                                {docType.label}
                                                            </h6>
                                                            
                                                            {/* Images Display */}
                                                            <div className="d-flex gap-3 mb-3 flex-wrap">
                                                                {/* Front Image */}
                                                                <div style={{ flex: '0 0 150px' }}>
                                                                    <label className="fw-semibold d-block mb-2">Front</label>
                                                                    <label className="d-block" style={{ cursor: 'pointer' }}>
                                                                        {hasFront ? (
                                                                            <div className="position-relative border border-success rounded overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                                                                <img 
                                                                                    src={URL.createObjectURL(hasFront)} 
                                                                                    alt="Front"
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover' }}
                                                                                />
                                                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100" style={{ transition: 'opacity 0.3s' }}>
                                                                                    <i className="fa fa-camera text-white fa-2x"></i>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-warning position-absolute top-0 end-0 m-2 rounded-circle"
                                                                                    style={{ width: '28px', height: '28px', padding: 0, zIndex: 10 }}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        removeNewDocument(docId, 'front');
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        ) : existingDoc?.images?.front && !removedDocuments.includes(`${existingDoc._id}-front`) ? (
                                                                            <div className="position-relative border rounded overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                                                                <img 
                                                                                    src={getDocumentImageUrl(existingDoc.images.front)} 
                                                                                    alt="Front"
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover' }}
                                                                                />
                                                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100" style={{ transition: 'opacity 0.3s' }}>
                                                                                    <i className="fa fa-camera text-white fa-2x"></i>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 rounded-circle"
                                                                                    style={{ width: '28px', height: '28px', padding: 0, zIndex: 10 }}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        removeExistingDocument(existingDoc._id, 'front');
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="border border-dashed rounded d-flex align-items-center justify-content-center text-muted" style={{ width: '150px', height: '150px', backgroundColor: '#f8f9fa' }}>
                                                                                <div className="text-center">
                                                                                    <i className="fa fa-plus-circle fa-2x mb-2 text-primary"></i>
                                                                                    <p className="mb-0 small">Click to upload</p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        <input
                                                                            type="file"
                                                                            className="d-none"
                                                                            accept="image/*"
                                                                            onChange={(e) => e.target.files && handleDocumentUpload(docId, 'front', e.target.files[0])}
                                                                        />
                                                                    </label>
                                                                </div>
                                                                
                                                                {/* Back Image */}
                                                                <div style={{ flex: '0 0 150px' }}>
                                                                    <label className="fw-semibold d-block mb-2">Back</label>
                                                                    <label className="d-block" style={{ cursor: 'pointer' }}>
                                                                        {hasBack ? (
                                                                            <div className="position-relative border border-success rounded overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                                                                <img 
                                                                                    src={URL.createObjectURL(hasBack)} 
                                                                                    alt="Back"
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover' }}
                                                                                />
                                                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100" style={{ transition: 'opacity 0.3s' }}>
                                                                                    <i className="fa fa-camera text-white fa-2x"></i>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-warning position-absolute top-0 end-0 m-2 rounded-circle"
                                                                                    style={{ width: '28px', height: '28px', padding: 0, zIndex: 10 }}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        removeNewDocument(docId, 'back');
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        ) : existingDoc?.images?.back && !removedDocuments.includes(`${existingDoc._id}-back`) ? (
                                                                            <div className="position-relative border rounded overflow-hidden" style={{ width: '150px', height: '150px' }}>
                                                                                <img 
                                                                                    src={getDocumentImageUrl(existingDoc.images.back)} 
                                                                                    alt="Back"
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover' }}
                                                                                />
                                                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100" style={{ transition: 'opacity 0.3s' }}>
                                                                                    <i className="fa fa-camera text-white fa-2x"></i>
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 rounded-circle"
                                                                                    style={{ width: '28px', height: '28px', padding: 0, zIndex: 10 }}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        removeExistingDocument(existingDoc._id, 'back');
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="border border-dashed rounded d-flex align-items-center justify-content-center text-muted" style={{ width: '150px', height: '150px', backgroundColor: '#f8f9fa' }}>
                                                                                <div className="text-center">
                                                                                    <i className="fa fa-plus-circle fa-2x mb-2 text-primary"></i>
                                                                                    <p className="mb-0 small">Click to upload</p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        <input
                                                                            type="file"
                                                                            className="d-none"
                                                                            accept="image/*"
                                                                            onChange={(e) => e.target.files && handleDocumentUpload(docId, 'back', e.target.files[0])}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Buttons. */}
                                            <SaveCancelButton loading={loading} color="text-white" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    )
}

export default EditProfile;